import { render, staticRenderFns } from "./UserDialog.vue?vue&type=template&id=15d21b1a&scoped=true"
import script from "./UserDialog.vue?vue&type=script&lang=js"
export * from "./UserDialog.vue?vue&type=script&lang=js"
import style0 from "./UserDialog.vue?vue&type=style&index=0&id=15d21b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d21b1a",
  null
  
)

export default component.exports